
import { defineComponent, Ref, ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import {ShipmentOrderType} from '@/services/data.d'
import {StateType as FddsignStateType} from '@/store/fddsign'
import { UserOutlined, InfoCircleOutlined, ExclamationCircleFilled } from '@ant-design/icons-vue';



import {message} from 'ant-design-vue'

interface AttestationSetupType {
    visible: Ref<boolean>;
    fddurl: Ref<string>;
    isShow: Ref<boolean>;
    loading: Ref<boolean>;
    certStatus: number | undefined | null;
    contStatus: number | undefined | null;
    handleCtrl: (e: MouseEvent) => void;
    handleSuce: (e: MouseEvent) => void;
    handleGoto: (type: string) => void;
    handleClose: (e: MouseEvent) => void;
}

export default defineComponent({
    name: 'Attestation',
    components:{
        UserOutlined,
        InfoCircleOutlined,
        ExclamationCircleFilled
    },
    props: {
        certStatus: Number,
        contStatus: Number,
        isVisible: {
            type: Boolean,
            default: ()=>{return true}
        }
    },
    emits: ['update:isVisible', 'reset'],
    setup(props, {emit}):AttestationSetupType {
        const {certStatus, contStatus, isVisible} = props
        const store = useStore<{fddsign: FddsignStateType}>()
        const router = useRouter()
        const userMsg = JSON.parse(String(localStorage.getItem('userMsg')))
        const visible = ref<boolean>(true)
        const isShow = ref<boolean>(true)
        const loading = ref<boolean>(false)
        const fddurl = ref<string>('')

        //法大大合同签署认证
        const curl = computed<string>(() => store.state.fddsign.signUrl)
        const fddActionContract = async(params:ShipmentOrderType) => {
            loading.value = true
            try {
                const res: boolean = await store.dispatch('fddsign/fddContractFn', params)
                if(res===true){
                    fddurl.value = curl.value
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            loading.value = false
        }

        //法大大合同信息认证
        const url = computed<string>(() => store.state.fddsign.signUrl)
        const fddAction = async(params:ShipmentOrderType) => {
            loading.value = true
            try {
                const res: boolean = await store.dispatch('fddsign/fddAuthenticationFn', params)
                if(res===true){
                    fddurl.value = url.value
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            loading.value = false
        }
        //认证
        const handleSuce = (e: MouseEvent) => {
            localStorage.setItem('oneType','two')
            router.replace('/personal/account')
            visible.value = false
        }
        const handleCtrl = (e: MouseEvent) => {
            localStorage.setItem('oneType','two')
            visible.value = false
            emit('update:isVisible', false)
        }

        //继续认证
        const handleGoto = (type:string) => {
            isShow.value = false
            const params = {userCode: userMsg?.userCode}
            type == 'act' ? fddAction(params) : fddActionContract(params)
        }

        //关闭弹框
        const handleClose = (e: MouseEvent) => {
            localStorage.setItem('oneType','two')
            emit('update:isVisible', false)
            emit('reset', true)
        }

        onMounted(()=>{
            console.log('certStatus',certStatus);
            console.log('contStatus',contStatus);
            console.log('visible',visible.value);
        })

        return {
            visible,
            fddurl,
            isShow,
            loading,
            certStatus,
            contStatus,
            handleCtrl,
            handleSuce,
            handleGoto,
            handleClose
        }
    }
})
